declare const ColorFresnel: any;

export class ColorFresnelModel {
  edge: [number, number, number];
  center: [number, number, number];
  centerBias: number;
  edgeBias: number;
  power: number;


  static toEngine(colorFresnel: ColorFresnelModel) {
    return [[...colorFresnel.center], [...colorFresnel.edge], colorFresnel.centerBias, colorFresnel.edgeBias, colorFresnel.power];
  }
}
